import { SuperInputBase } from "@components:SuperInput/SuperInput.Base";
import { SuperInputProps } from "@components:SuperInput/types";
import { Autocomplete, AutocompleteProps } from "@mui/material";

export type SuperInputAutocompleteProps = SuperInputProps &
  AutocompleteProps<any, any, any, any> & {
    width?: string;
  };

export const SuperInputAutocomplete = ({
  label,
  helperText,
  explainText,
  sx,
  width,
  errorText,
  required,
  autoHeight,
  ...props
}: SuperInputAutocompleteProps) => {
  return (
    <SuperInputBase
      label={label}
      helperText={helperText}
      explainText={explainText}
      errorText={errorText}
      required={required}
      autoHeight={autoHeight}
      sx={sx}
    >
      <Autocomplete
        {...props}
        className={"SuperInput__Autocomplete with-bg"}
        sx={{
          width: width ?? undefined,
        }}
      />
    </SuperInputBase>
  );
};
